import type { DecimalValue } from "../../values/decimal";
import type { DashboardDateRange } from "../dashboard";
import { DASHBOARD_COPY } from "../dashboard-copy";
import { bar, countBy, inRange, labelOrFallback, stat, sumBy, type AreaSummary } from "./build";

type RoleVisibleDocumentVersion = { documentType: string; isCurrent: boolean; uploadedAt: Date | string };

export type InventoryInput = {
  chemicals: ReadonlyArray<{ location: string | null; amount: DecimalValue; unit: string }>;
  documents: readonly RoleVisibleDocumentVersion[];
};

export function summarizeInventory({ chemicals, documents }: InventoryInput, range: DashboardDateRange): AreaSummary {
  return {
    currentBatches: stat(chemicals.length),
    batchesByLocation: bar(countBy(chemicals, (chemical) => labelOrFallback(chemical.location, DASHBOARD_COPY.unknown))),
    stockByUnit: bar(sumBy(chemicals, (chemical) => chemical.unit, (chemical) => chemical.amount)),
    documentsByType: bar(countBy(documents.filter((document) => document.isCurrent), (document) => document.documentType)),
    documentUploads: stat(documents.filter((document) => inRange(document.uploadedAt, range)).length),
  };
}
